/**
 * Purchasing Settings Tab.
 * Note: Commodity Groups and Types have been moved to Platform tab per client request.
 */

import { ExportTemplatesSection } from './ExportTemplatesSection';
import { OpenOrdersSection } from './OpenOrdersSection';

export function PurchasingTab() {
  return (
    <div className="space-y-6">
      <OpenOrdersSection />
      <ExportTemplatesSection />
    </div>
  );
}
